var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsEdit = function SvgIconsEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.4,
    height: 14.4,
    viewBox: "0 0 14.4 14.4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6 11.707c.331 0 .6.267.6.596a.598.598 0 0 1-.53.592l-.07.004H7.2a.598.598 0 0 1-.6-.596c0-.305.232-.557.53-.592l.07-.004h5.4zM9.476 2.045a1.881 1.881 0 0 1 1.809-.482 1.867 1.867 0 0 1 1.324 1.316c.162.602.01 1.242-.4 1.707l-.085.09-7.5 7.453a.6.6 0 0 1-.201.132l-.077.024-2.4.597a.599.599 0 0 1-.74-.658l.012-.065.6-2.385a.595.595 0 0 1 .104-.216l.054-.06 7.5-7.453zm1.498.67a.676.676 0 0 0-.59.12l-.06.053-7.382 7.335-.318 1.26 1.269-.315 7.383-7.334a.666.666 0 0 0 .197-.491l-.007-.078-.016-.077a.67.67 0 0 0-.476-.473z",
    fillRule: "nonzero"
  }))));
};
export default SvgIconsEdit;